import { render, staticRenderFns } from "./statementDetail.vue?vue&type=template&id=67ee04d9&scoped=true"
import script from "./statementDetail.vue?vue&type=script&lang=js"
export * from "./statementDetail.vue?vue&type=script&lang=js"
import style0 from "./statementDetail.vue?vue&type=style&index=0&id=67ee04d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ee04d9",
  null
  
)

export default component.exports